<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPageLoader"
      :color="loaderColor"
    ></loading>
    <div class="w-full" style="min-height: 300px;">
      <v-wait for="senderdetail">
        <half-circle-spinner
          style="display: block; margin: 125px auto 0"
          :animation-duration="1000"
          :size="60"
          color="#3d4852"
          slot="waiting"
        />
        <div id="user-view" class="flex flex-col bg-white rounded w-full pt-4">
          <div class="px-6 pt-1 pb-4 create-sender-header">
            <div class="text-xl text-lg font-bold">
              {{ $t('frontend_groovemail_segment_subscribe_settings') }}
            </div>
            <div class="text-grey-800 text-sm">
              {{ $t('frontend_groovemail_segment_subscribe_configure') }}
            </div>
          </div>
          <div class="flex w-full text-left">
            <div class="w-full border-b border-grey-200">
              <gd-tabs
                :tabs="tabs"
                :currentTab="currentTab"
                :disableNotCompleted="false"
                :wrapper-class="'px-6 gs-default-tabs'"
                :tab-class="mainTabClass"
                :tab-active-class="'border-pink border-b-2 text-pink gs-default-tabs-item-active'"
                :line-class="'gs-default-tabs-active-line'"
                @onClick="handleTabChange"
              />
            </div>
          </div>
          <div class="relative p-6 pb-0">
            <div>
              <div v-if="currentTab === 'senderInfo'">
                <div class="flex flex-col mb-6">
                  <label class="font-semibold text-sm text-grey-700 mb-2">
                    {{
                      $t(
                        'frontend_groovemail_segment_subscribe_sender_identity'
                      )
                    }}
                  </label>
                  <text-input
                    class="text-dark text-sm"
                    :validator="$v.model.name"
                    :attribute="
                      this.$t(
                        'frontend_groovemail_segment_subscribe_sender_identity'
                      )
                    "
                    v-model="model.name"
                    value="model.name"
                    :placeholder="
                      this.$t(
                        'frontend_groovemail_sender_enter_sender_identity'
                      )
                    "
                  />
                </div>

                <div class="flex flex-col mb-6">
                  <label class="font-semibold text-sm text-grey-700 mb-2">
                    {{
                      $t('frontend_groovemail_segment_subscribe_sender_name')
                    }}
                  </label>
                  <text-input
                    class="text-dark text-sm"
                    :validator="$v.model.sender_name"
                    :attribute="
                      this.$t(
                        'frontend_groovemail_segment_subscribe_sender_name'
                      )
                    "
                    v-model="model.sender_name"
                    value="model.sender_name"
                    :placeholder="
                      this.$t('frontend_groovemail_sender_enter_sender_name')
                    "
                  />
                </div>

                <div class="flex flex-col mb-6">
                  <label class="font-semibold text-sm text-grey-700 mb-2">
                    {{
                      $t('frontend_groovemail_segment_subscribe_sender_email')
                    }}
                  </label>
                  <text-input
                    class="text-dark text-sm"
                    :validator="$v.model.sender_email"
                    :attribute="
                      this.$t(
                        'frontend_groovemail_segment_subscribe_sender_email'
                      )
                    "
                    v-model="model.sender_email"
                    value="model.sender_email"
                    :placeholder="
                      this.$t('frontend_groovemail_sender_enter_sender_email')
                    "
                  />
                </div>

                <div class="flex flex-col mb-6">
                  <label class="font-semibold text-sm text-grey-700 mb-2">
                    {{
                      $t('frontend_groovemail_segment_subscribe_reply_email')
                    }}
                  </label>
                  <text-input
                    class="text-dark text-sm"
                    :validator="$v.model.reply_email"
                    :attribute="
                      this.$t(
                        'frontend_groovemail_segment_subscribe_reply_email'
                      )
                    "
                    v-model="model.reply_email"
                    value="model.reply_email"
                    :placeholder="
                      this.$t('frontend_groovemail_sender_enter_reply_email')
                    "
                  />
                </div>

                <div class="flex flex-col mb-6">
                  <label class="font-semibold text-sm text-grey-700 mb-2">
                    {{ $t('frontend_groovemail_segment_subscribe_default') }}
                  </label>
                  <gd-toggle
                    class="rounded-full"
                    :value="model.is_default"
                    @change="changedefault"
                  />
                </div>

                <div class="flex flex-col mb-6">
                  <label class="font-semibold text-sm text-grey-700 mb-2">
                    <span
                      >{{ $t('frontend_groovemail_email_sender_smtp_driver') }}
                    </span>
                  </label>

                  <div
                    class="custom-radio-list"
                    v-for="(option, index) in smtp_options"
                    :key="index"
                  >
                    <gd-custom-radio
                      v-model="model.smtp_driver"
                      :option="option"
                      value="model.smtp_driver"
                      @onUpdateOption="smtpDriverUpdated(option)"
                    ></gd-custom-radio>
                  </div>
                  <div
                    class="flex text-sm text-grey-700 items-center mb-6"
                    v-if="model.smtp_driver === 3"
                  >
                    <InfoIcon class="mr-2" />
                    {{
                      $t(
                        'frontend_groovemail_need_help_for_connecting_sendgrid_account'
                      )
                    }}<span class="mx-1">-</span>
                    <span
                      class="cursor-pointer text-pink underline"
                      @click="
                        openWalkthroughVideoForExternalSmtp(model.smtp_driver)
                      "
                    >
                      {{
                        $t(
                          'frontend_groovemail_click_here_for_sendgrid_video_link'
                        )
                      }} </span
                    ><span>.</span>
                  </div>
                  <div
                    class="flex text-sm text-grey-700 items-center mb-6"
                    v-if="model.smtp_driver === 5"
                  >
                    <InfoIcon class="mr-2" />
                    {{
                      $t(
                        'frontend_groovemail_need_help_for_connecting_aws_account'
                      )
                    }}<span class="mx-1">-</span>
                    <span
                      class="cursor-pointer text-pink underline"
                      @click="openStepsForAwsSmtp"
                    >
                      {{
                        $t('frontend_groovemail_click_here_for_aws_steps')
                      }} </span
                    ><span
                      >.
                      {{ $t('frontend_groovemail_mandatory_aws_setup_note') }}
                    </span>
                  </div>
                  <div
                    class="flex text-sm text-grey-700 items-center mb-6"
                    v-if="model.smtp_driver === 2"
                  >
                    <InfoIcon class="mr-2" />
                    {{
                      $t(
                        'frontend_groovemail_need_help_for_connecting_mailgun_account'
                      )
                    }}<span class="mx-1">-</span>
                    <span
                      class="cursor-pointer text-pink underline"
                      @click="openStepsForMailgunSmtp"
                    >
                      {{
                        $t('frontend_groovemail_click_here_for_aws_steps')
                      }} </span
                    ><span>.</span>
                  </div>
                  <div>
                    <p
                      v-if="this.formSubmitted && this.model.smtp_driver === 0"
                      class="w-full error text-pink-dark mt-1 text-sm"
                    >
                      {{
                        $t(
                          'frontend_groovemail_email_sender_please_select_smtp_driver'
                        )
                      }}
                    </p>
                  </div>
                </div>

                <div
                  class="flex flex-col mb-6"
                  v-if="model.smtp_driver === 2 || model.smtp_driver === 5"
                >
                  <label class="font-semibold text-sm text-grey-700 mb-2">
                    {{
                      $t(
                        'frontend_groovemail_email_sender_settings_user_name_key'
                      )
                    }}
                  </label>
                  <text-input
                    :validator="$v.smtp_model.user_name"
                    :attribute="
                      this.$t(
                        'frontend_groovemail_email_sender_settings_user_name_key'
                      )
                    "
                    v-model="smtp_model.user_name"
                    value="smtp_model.user_name"
                    :placeholder="
                      this.$t(
                        'frontend_groovemail_email_sender_settings_enter_user_name'
                      )
                    "
                  />
                </div>

                <div
                  class="flex flex-col mb-6"
                  v-if="
                    model.smtp_driver === 2 ||
                    model.smtp_driver === 3 ||
                    model.smtp_driver === 4 ||
                    model.smtp_driver === 5
                  "
                >
                  <label class="font-semibold text-sm text-grey-700 mb-2">
                    {{
                      model.smtp_driver === 2 || model.smtp_driver === 5
                        ? $t(
                            'frontend_groovemail_email_sender_settings_password'
                          )
                        : $t(
                            'frontend_groovemail_email_sender_settings_api_key'
                          )
                    }}
                  </label>
                  <text-input
                    :validator="$v.smtp_model.api_key"
                    :attribute="
                      model.smtp_driver === 2 || model.smtp_driver === 5
                        ? this.$t(
                            'frontend_groovemail_email_sender_settings_password'
                          )
                        : this.$t(
                            'frontend_groovemail_email_sender_settings_api_key'
                          )
                    "
                    v-model="smtp_model.api_key"
                    value="smtp_model.api_key"
                    :placeholder="
                      model.smtp_driver === 2 || model.smtp_driver === 5
                        ? this.$t(
                            'frontend_groovemail_email_sender_settings_enter_password'
                          )
                        : this.$t(
                            'frontend_groovemail_email_sender_settings_enter_api_key'
                          )
                    "
                  />
                </div>

                <div class="flex flex-col mb-6" v-if="model.smtp_driver === 2">
                  <label class="font-semibold text-sm text-grey-700 mb-2">
                    {{
                      $t(
                        'frontend_groovemail_email_sender_settings_webhook_signing_key'
                      )
                    }}
                  </label>
                  <text-input
                    :validator="$v.smtp_model.webhook_signing_key"
                    :attribute="
                      this.$t(
                        'frontend_groovemail_email_sender_settings_webhook_signing_key'
                      )
                    "
                    v-model="smtp_model.webhook_signing_key"
                    value="smtp_model.webhook_signing_key"
                    :placeholder="
                      this.$t(
                        'frontend_groovemail_email_sender_settings_enter_webhook_signing_key'
                      )
                    "
                  />
                </div>

                <div class="flex flex-col mb-6" v-if="model.smtp_driver === 5">
                  <label class="font-semibold text-sm text-grey-700 mb-2">
                    {{
                      $t(
                        'frontend_groovemail_email_sender_settings_server_name'
                      )
                    }}
                  </label>
                  <text-input
                    :validator="$v.smtp_model.server"
                    :attribute="
                      this.$t(
                        'frontend_groovemail_email_sender_settings_server_name'
                      )
                    "
                    v-model="smtp_model.server"
                    value="smtp_model.server"
                    :placeholder="
                      this.$t(
                        'frontend_groovemail_email_sender_settings_enter_server_name'
                      )
                    "
                  />
                </div>
                <div class="flex flex-col mb-6" v-if="model.smtp_driver === 5">
                  <label class="font-semibold text-sm text-grey-700 mb-2">
                    {{
                      $t(
                        'frontend_groovemail_email_sender_settings_configuration_set'
                      )
                    }}
                  </label>
                  <text-input
                    :validator="$v.smtp_model.configuration_set"
                    :attribute="
                      this.$t(
                        'frontend_groovemail_email_sender_settings_configuration_set'
                      )
                    "
                    v-model="smtp_model.configuration_set"
                    value="smtp_model.configuration_set"
                    :placeholder="
                      this.$t(
                        'frontend_groovemail_email_sender_settings_enter_configuration_set'
                      )
                    "
                  />
                </div>
                <div
                  class="mb-2"
                  v-if="
                    this.model.smtp_driver === 2 ||
                    this.model.smtp_driver === 3 ||
                    this.model.smtp_driver === 4 ||
                    this.model.smtp_driver === 5
                  "
                >
                  <label class="font-semibold text-sm text-grey-700">
                    {{ $t('frontend_groovemail_senders_webhook_url') }}
                  </label>
                  <label class="font-semibold text-sm text-grey-700">
                    {{
                      $t('frontend_groovemail_senders_webhook_selected_events')
                    }}
                  </label>
                </div>
                <div
                  class="flex mb-6"
                  v-if="
                    this.model.smtp_driver === 2 ||
                    this.model.smtp_driver === 3 ||
                    this.model.smtp_driver === 4 ||
                    this.model.smtp_driver === 5
                  "
                >
                  <div class="w-11/12">
                    <text-input
                      v-model="webhookUrl"
                      value="webhookUrl"
                      :disabled="true"
                      :placeholder="this.$t('frontend_product_step8_webhook')"
                    />
                  </div>
                  <gd-button
                    v-clipboard:copy="webhookUrl"
                    v-clipboard:success="onCopyWeebhookUrl"
                    v-clipboard:error="onErrorWebhookUrl"
                    class="
                      h-10
                      w-1/12
                      btn-width
                      px-4
                      btn-radius
                      text-base
                      font-semibold
                      border-grey-300
                      ml-2
                    "
                    primary
                    size="auto"
                  >
                    {{ $t('frontend_copy') }}
                  </gd-button>
                </div>
              </div>
              <div v-if="currentTab === 'businessInfo'">
                <div class="flex flex-col mb-6">
                  <label class="font-semibold text-sm text-grey-700 mb-2">{{
                    $t('frontend_groovemail_segment_company_name')
                  }}</label>
                  <text-input
                    class="text-dark text-sm"
                    :validator="$v.model.company_name"
                    :attribute="
                      this.$t('frontend_groovemail_segment_company_name')
                    "
                    v-model="model.company_name"
                    value="model.company_name"
                    :placeholder="
                      this.$t('frontend_groovemail_sender_enter_company_name')
                    "
                  />
                </div>

                <div class="flex flex-col mb-6">
                  <label class="font-semibold text-sm text-grey-700 mb-2">{{
                    $t('frontend_groovemail_segment_company_address')
                  }}</label>
                  <text-input
                    class="text-dark text-sm"
                    :validator="$v.model.address"
                    :attribute="
                      this.$t('frontend_groovemail_segment_company_address')
                    "
                    v-model="model.address"
                    value="model.address"
                    :placeholder="
                      this.$t('frontend_groovemail_sender_enter_address')
                    "
                  />
                </div>
              </div>
            </div>
            <div class="flex justify-end pb-6 create-sender-save-btn">
              <gd-button
                class="h-10 btn-width px-4 btn-radius text-base font-semibold"
                size="large"
                primary
                :disabled="this.userCanMail ? false : true"
                @click="userCanMail ? createSetting() : null"
              >
                {{ $t('frontend_save') }}
              </gd-button>
            </div>
          </div>
        </div>
      </v-wait>
    </div>

    <gd-modal
      class="custom-modal"
      id="external-smtp-setup-walkthrough-video"
      name="external-smtp-setup-walkthrough-video"
      :title="
        this.$t(
          'frontend_groovemail_need_help_for_connecting_external_smtp_account_title'
        )
      "
    >
      <div class="p-6">
        <iframe
          class="border border-grey-200"
          width="550"
          height="310"
          :src="turialLinkForExternalSmtp"
          :title="$t('frontend_groovemail_sendgrid_smtp_setup')"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </gd-modal>

    <gd-modal
      class="custom-modal"
      id="smtp-setup-walkthrough-steps"
      name="smtp-setup-walkthrough-steps"
      :title="
        this.$t(
          'frontend_groovemail_need_help_for_connecting_aws_account_title'
        )
      "
    >
      <VuePerfectScrollbar
        class="overflow-scroll"
        style="max-height: calc(-250px + 100vh)"
      >
        <div class="p-6 w-full">
          <div
            v-for="(step, index) in senderCreationSteps"
            :key="index"
            class="w-full"
          >
            <div>
              <span v-html="step.stepLabel"></span>
            </div>
            <div v-if="step.subSteps" class="ml-5">
              <li
                v-for="(subStep, index) in step.subSteps"
                :key="index"
                v-html="subStep.subStepLabel"
                class="w-full"
              ></li>
            </div>
          </div>
        </div>
      </VuePerfectScrollbar>
    </gd-modal>

    <gd-modal
      class="custom-modal"
      id="senders-detail-modal"
      name="senders-detail-modal"
      :title="this.$t('frontend_groovemail_campains_step2_sender')"
    >
      <div class="p-6">
        <div class="flex relative">
          <div class="flex justify-center mb-5 w-full">
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x=".5"
                y=".5"
                width="39"
                height="39"
                rx="5.5"
                fill="#FFDEE4"
                stroke="#EA3D5E"
              />
              <path
                d="m15 15 10 10M25 15 15 25"
                stroke="#EA3D5E"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </div>
          <div
            class="absolute right-0 cursor-pointer"
            @click="closeSenderDetailModal"
          >
            <CloseIcon />
          </div>
        </div>
        <VuePerfectScrollbar
          class="overflow-scroll"
          style="max-height: calc(-250px + 100vh)"
        >
          <div class="text-center" v-html="senderLinkedModulesTemplate"></div>
        </VuePerfectScrollbar>
        <div class="flex text-center">
          <div>
            <p class="text-sm font-bold text-deep-dark mt-6 mb-4">
              {{
                this.$t(
                  'frontend_groovemail_senders_update_verified_sender_warning'
                )
              }}
            </p>
            <text-input
              class="text-dark text-sm"
              v-model="senderUpdateText"
              value="senderUpdateText"
              :placeholder="
                this.$t(
                  'frontend_groovemail_senders_update_verified_sender_add_yes_placeholder'
                )
              "
            />
            <div
              class="text-sm text-left text-pink-dark mt-2"
              v-if="
                this.senderUpdateInitiated &&
                this.senderUpdateText.toLowerCase() !== 'yes'
              "
            >
              {{
                this.$t(
                  'frontend_groovemail_senders_update_verified_sender_add_yes'
                )
              }}
            </div>
          </div>
        </div>
        <div class="flex justify-center mt-6">
          <gd-button
            class="
              h-10
              delete-sender-btn
              btn-width
              px-4
              btn-radius
              text-base
              font-semibold
              border-grey-300
            "
            size="auto"
            @click="updateCurrentSender"
          >
            {{ $t('frontend_update') }}
          </gd-button>
          <gd-button
            class="
              h-10
              close-sender-modal-btn
              btn-width
              px-4
              btn-radius
              text-base
              font-semibold
              border-grey-300
              ml-2
            "
            primary
            size="auto"
            @click="closeSenderDetailModal"
          >
            {{ $t('frontend_close') }}</gd-button
          >
        </div>
      </div>
    </gd-modal>
  </div>
</template>

<script>
import axios from 'axios';
import auth from '@groovepages/gd-lib/auth';
import Loading from 'vue-loading-overlay';
import {
  required,
  minLength,
  maxLength,
  email,
} from 'vuelidate/lib/validators';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Notify from '@groovepages/gd-lib/notify';
import Sender from './models/Sender';
import themeConfig from './theme/themeConfig.js';
import 'vue-loading-overlay/dist/vue-loading.css';
import InfoIcon from './assets/images/icons/info-icon.svg';
import CloseIcon from './assets/images/icons/close-icon.svg';
import showAlert from './components/sweet-alert-popup.js';
import GdCustomRadio from './components/GdCustomRadio.vue'

export default {
  middleware: 'auth',

  metaInfo() {
    return { title: this.$t('frontend_groovemail_sender_title') };
  },
  props: {
    btnValue: {
      type: String,
      default: ''
    },
    senderId: {
      type: String,
      default: ''
    },
  },

  data() {
    return {
      senderLinkedModulesTemplate: '',
      senderLinkedModulesCount: 0,
      senderUpdateInitiated: false,
      senderUpdateText: '',
      webhookUrl: '',
      turialLinkForExternalSmtp: '',
      formSubmitted: false,
      currentTab: 'senderInfo',
      model: {
        company_name: '',
        address: '',
        name: '',
        sender_name: '',
        sender_email: '',
        reply_email: '',
        is_default: 0,
        smtp_driver: 0,
      },
      smtp_model: {
        user_name: '',
        api_key: '',
        server: '',
        configuration_set: '',
        webhook_signing_key: '',
      },
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      senderCreationSteps: [],
      genericUrl: `${window.config.apiUrl.split('/api')[0]}/api`,
      userCanMail: null,
      userCanAccessInternalSmtp: null,
      sender: {},
    };
  },

  components: {
    Loading,
    InfoIcon,
    VuePerfectScrollbar,
    CloseIcon,
    GdCustomRadio,
  },

  validations: {
    model: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
      sender_name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
      sender_email: {
        required,
        email,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
      reply_email: {
        required,
        email,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
      company_name: {
        required,
      },
      address: {
        required,
      },
    },
    smtp_model: {
      user_name: {
        required,
      },
      api_key: {
        required,
      },
      server: {
        required,
      },
      configuration_set: {
        required,
      },
      webhook_signing_key: {
        required,
      },
    },
  },

  methods: {
    sendersLinkedModules(data) {
      let senderDetailTemplate = `<p class="text-lg font-bold text-deep-dark mb-3"> ${this.$t(
        'frontend_groovemail_senders_deletion_swal_heading_text'
      )}</p>
        <p class="text-sm text-deep-dark mb-6"> ${this.$t(
          'frontend_groovemail_senders_deletion_swal_subheading_text'
        )}</p>`;

      if (
        data.campaigns &&
        data.campaigns.length > 0 &&
        !data.campaigns.every((element) => element === null)
      ) {
        senderDetailTemplate += `<p class="text-sm text-deep-dark font-bold mb-4">${this.$t(
          'frontend_groovemail_broadcasts_route_page_title'
        )}: <span class="font-normal">${data.campaigns.join(', ')}</span></p>`;
      }
      if (
        data.forms &&
        data.forms.length > 0 &&
        !data.forms.every((element) => element === null)
      ) {
        senderDetailTemplate += `<p class="text-sm text-deep-dark font-bold mb-4">${this.$t(
          'frontend_groovemail_forms_route_page_title'
        )}: <span class="font-normal">${data.forms.join(', ')}</span></p>`;
      }
      if (
        data.sequences &&
        data.sequences.length > 0 &&
        !data.sequences.every((element) => element === null)
      ) {
        senderDetailTemplate += `<p class="text-sm text-deep-dark font-bold">${this.$t(
          'frontend_groovemail_sequences_route_page_title'
        )}: <span class="font-normal">${data.sequences.join(', ')}</span></p>`;
      }
      return senderDetailTemplate;
    },

    closeSenderDetailModal() {
      this.$root.$emit('modal-close', 'senders-detail-modal');
    },

    async updateCurrentSender() {
      this.senderUpdateInitiated = true;
      if (this.senderUpdateText.toLowerCase() === 'yes') {
        await this.senderCreateUpdate();
      }
    },

    onCopyWeebhookUrl() {
      Notify.success(
        this.$t('frontend_groovemail_senders_webhook_url_copy_success')
      );
    },

    onErrorWebhookUrl() {
      Notify.fail(
        this.$t('frontend_groovemail_senders_webhook_url_copy_error')
      );
    },

    openWalkthroughVideoForExternalSmtp(driverType) {
      if (driverType === 3) {
        this.turialLinkForExternalSmtp =
          'https://www.youtube.com/embed/SbspqKZAtFg';
      }
      this.$root.$emit('modal-open', 'external-smtp-setup-walkthrough-video');
    },

    openStepsForAwsSmtp() {
      this.senderCreationSteps = [...this.awsSteps];
      this.$root.$emit('modal-open', 'smtp-setup-walkthrough-steps');
    },

    openStepsForMailgunSmtp() {
      this.senderCreationSteps = [...this.mailgunSteps];
      this.$root.$emit('modal-open', 'smtp-setup-walkthrough-steps');
    },

    smtpDriverUpdated(option) {
      this.getWebhookUrl(option.id);
      this.$v.smtp_model.api_key.$reset();
      this.formSubmitted = false;
    },

    getWebhookUrl(driverId) {
      switch (driverId) {
        case 2:
          this.webhookUrl = `https://v1.gdapis.com/api/groovemail/handle-mailgun-webhook/${this.$store.state.user.id}`;
          break;
        case 3:
          this.webhookUrl = `https://v1.gdapis.com/api/groovemail/handle-sendgrid-webhook/${this.$store.state.user.id}`;
          break;
        case 4:
          this.webhookUrl = `https://v1.gdapis.com/api/groovemail/handle-sparkpost-webhook/${this.$store.state.user.id}`;
          break;
        case 5:
          this.webhookUrl = `https://v1.gdapis.com/api/groovemail/handle-ses-webhook/${this.$store.state.user.id}`;
          break;
        default:
          this.webhookUrl = '';
      }
    },

    handleTabChange(newTab) {
      this.currentTab = newTab;
    },

    changedefault() {
      this.model.is_default = this.model.is_default != 1 ? 1 : 0;
    },

    async createNewSender() {
      this.$v.model.name.$touch();
      this.$v.model.sender_name.$touch();
      this.$v.model.sender_email.$touch();
      this.$v.model.company_name.$touch();
      this.$v.model.address.$touch();
      this.$v.model.reply_email.$touch();
      if (this.model.smtp_driver === 2) {
        this.$v.smtp_model.user_name.$touch();
        this.$v.smtp_model.api_key.$touch();
        this.$v.smtp_model.webhook_signing_key.$touch();
      } else if (this.model.smtp_driver === 3) {
        this.$v.smtp_model.api_key.$touch();
      } else if (this.model.smtp_driver === 4) {
        this.$v.smtp_model.api_key.$touch();
      } else if (this.model.smtp_driver === 5) {
        this.$v.smtp_model.user_name.$touch();
        this.$v.smtp_model.api_key.$touch();
        this.$v.smtp_model.server.$touch();
        this.$v.smtp_model.configuration_set.$touch();
      }
      this.formSubmitted = true;
      if (
        this.$v.model.name.$invalid ||
        this.$v.model.sender_name.$invalid ||
        this.$v.model.sender_email.$invalid ||
        this.$v.model.reply_email.$invalid ||
        this.checkSmtpSettingsInvalid()
      ) {
        this.currentTab = 'senderInfo';
      } else if (
        this.$v.model.company_name.$invalid ||
        this.$v.model.address.$invalid
      ) {
        this.currentTab = 'businessInfo';
      } else {
        this.showLoader();
        const sender = {};
        sender.name = this.model.name;
        sender.sender_name = this.model.sender_name;
        sender.sender_email = this.model.sender_email.toLowerCase();
        sender.reply_email = this.model.reply_email.toLowerCase();
        sender.company_name = this.model.company_name;
        sender.address = this.model.address;
        sender.is_default = this.model.is_default;
        sender.driver = this.model.smtp_driver;
        if (this.model.smtp_driver === 2) {
          sender.user_name = this.smtp_model.user_name;
          sender.api_key = this.smtp_model.api_key;
          sender.webhook_signing_key = this.smtp_model.webhook_signing_key;
        } else if (this.model.smtp_driver === 3) {
          sender.api_key = this.smtp_model.api_key;
        } else if (this.model.smtp_driver === 4) {
          sender.api_key = this.smtp_model.api_key;
        } else if (this.model.smtp_driver === 5) {
          sender.user_name = this.smtp_model.user_name;
          sender.api_key = this.smtp_model.api_key;
          sender.server = this.smtp_model.server;
          sender.configuration_set = this.smtp_model.configuration_set;
        }
        const response = await axios.post(`${this.genericUrl}/groovemail/sender`, sender);
        this.hideLoader();
        if (response.data.error) {
          this.currentTab = 'senderInfo';
          await showAlert({
            iconType: 'alert-error',
            html: `<p class="text-sm text-deep-dark"> ${response.data.error}</p>`,
            showCancelButton: false,
            showCloseButton: true,
            confirmButtonColor: '#fd6481',
            confirmButtonText: this.$t('frontend_close'),
          });
        } else {
          this.$emit('emailSenderCreated', response.data);
        }
      }
    },

    async createSetting() {
      this.$v.model.name.$touch();
      this.$v.model.sender_name.$touch();
      this.$v.model.sender_email.$touch();
      this.$v.model.company_name.$touch();
      this.$v.model.address.$touch();
      this.$v.model.reply_email.$touch();
      if (this.model.smtp_driver === 2) {
        this.$v.smtp_model.user_name.$touch();
        this.$v.smtp_model.api_key.$touch();
        this.$v.smtp_model.webhook_signing_key.$touch();
      } else if (this.model.smtp_driver === 3) {
        this.$v.smtp_model.api_key.$touch();
      } else if (this.model.smtp_driver === 4) {
        this.$v.smtp_model.api_key.$touch();
      } else if (this.model.smtp_driver === 5) {
        this.$v.smtp_model.user_name.$touch();
        this.$v.smtp_model.api_key.$touch();
        this.$v.smtp_model.server.$touch();
        this.$v.smtp_model.configuration_set.$touch();
      }
      this.formSubmitted = true;
      if (
        this.$v.model.name.$invalid ||
        this.$v.model.sender_name.$invalid ||
        this.$v.model.sender_email.$invalid ||
        this.$v.model.reply_email.$invalid ||
        this.checkSmtpSettingsInvalid()
      ) {
        this.currentTab = 'senderInfo';
      } else if (
        this.$v.model.company_name.$invalid ||
        this.$v.model.address.$invalid
      ) {
        this.currentTab = 'businessInfo';
      } else {
        // call api and check if it has linked modules
        if (
          this.senderLinkedModulesCount > 0 &&
          this.btnValue == 'EditSender' &&
          this.sender.is_verified == 1 &&
          this.sender.sender_email !== this.model.sender_email.toLowerCase()
        ) {
          this.senderUpdateInitiated = false;
          this.senderUpdateText = '';
          this.$root.$emit('modal-open', 'senders-detail-modal');
          return false;
        }
        await this.senderCreateUpdate();
      }
    },

    async senderCreateUpdate() {
      
      this.showLoader();
      this.sender.name = this.model.name;
      this.sender.sender_name = this.model.sender_name;
      this.sender.sender_email = this.model.sender_email.toLowerCase();
      this.sender.reply_email = this.model.reply_email.toLowerCase();
      this.sender.company_name = this.model.company_name;
      this.sender.address = this.model.address;
      this.sender.is_default = this.model.is_default;
      this.sender.driver = this.model.smtp_driver;
      if (this.model.smtp_driver === 2) {
        this.sender.user_name = this.smtp_model.user_name;
        this.sender.api_key = this.smtp_model.api_key;
        this.sender.webhook_signing_key = this.smtp_model.webhook_signing_key;
      } else if (this.model.smtp_driver === 3) {
        this.sender.api_key = this.smtp_model.api_key;
      } else if (this.model.smtp_driver === 4) {
        this.sender.api_key = this.smtp_model.api_key;
      } else if (this.model.smtp_driver === 5) {
        this.sender.user_name = this.smtp_model.user_name;
        this.sender.api_key = this.smtp_model.api_key;
        this.sender.server = this.smtp_model.server;
        this.sender.configuration_set = this.smtp_model.configuration_set;
      }
      let response = null;
      if (this.btnValue == 'EditSender') {
        response = await axios.put(
          `${this.genericUrl}/groovemail/sender/${this.senderId}`,
          this.sender
        );
      } else if (this.btnValue == 'NewSender') {
        response = await axios.post(`${this.genericUrl}/groovemail/sender`, this.sender);
      }
      this.hideLoader();
      if (response.data.error) {
        this.currentTab = 'senderInfo';
        await showAlert({
          iconType: 'alert-error',
          html: `<p class="text-sm text-deep-dark"> ${response.data.error}</p>`,
          showCancelButton: false,
          showCloseButton: true,
          confirmButtonColor: '#fd6481',
          confirmButtonText: this.$t('frontend_close'),
        });
      } else {
        this.$emit("fetchSender");
        this.$root.$emit('modal-close', 'create-sender-modal');
      }
    },

    checkSmtpSettingsInvalid() {
      if (this.model.smtp_driver === 0) {
        return true;
      }
      if (
        this.model.smtp_driver === 2 &&
        (this.$v.smtp_model.user_name.$invalid ||
          this.$v.smtp_model.api_key.$invalid ||
          this.$v.smtp_model.webhook_signing_key.$invalid)
      ) {
        return true;
      }
      if (this.model.smtp_driver === 3 && this.$v.smtp_model.api_key.$invalid) {
        return true;
      }
      if (this.model.smtp_driver === 4 && this.$v.smtp_model.api_key.$invalid) {
        return true;
      }
      if (
        this.model.smtp_driver === 5 &&
        (this.$v.smtp_model.user_name.$invalid ||
          this.$v.smtp_model.api_key.$invalid ||
          this.$v.smtp_model.server.$invalid ||
          this.$v.smtp_model.configuration_set.$invalid)
      ) {
        return true;
      }
      return false;
    },

    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
  },

  async created() {
    this.$wait.start('senderdetail');
    const dashboardData = await axios.get(`${this.genericUrl}/groovemail/dashboard`);
    this.userCanMail = dashboardData.data.can_mail;
    this.userCanAccessInternalSmtp = dashboardData.data.groovemail_smtp_enable;
    if (this.senderId == undefined) {
      this.sender = new Sender({});
    } else if (this.senderId && this.btnValue === 'EditSender') {
      const senderData = await axios.get(`${this.genericUrl}/groovemail/sender/${this.senderId}`);
      this.sender = senderData.data.data;
      this.senderLinkedModulesTemplate = this.sendersLinkedModules(
        senderData.data.modules
      );
      this.senderLinkedModulesCount =
        senderData.data.modules.campaigns.length +
        senderData.data.modules.forms.length +
        senderData.data.modules.sequences.length;
      this.model.name = this.sender.name;
      this.model.sender_name = this.sender.sender_name;
      this.model.sender_email = this.sender.sender_email;
      this.model.reply_email = this.sender.reply_email;
      this.model.company_name = this.sender.company_name;
      this.model.address = this.sender.address;
      this.model.is_default = this.sender.is_default;
      this.model.smtp_driver =
        !this.userCanAccessInternalSmtp && this.sender.driver === 1
          ? 0
          : this.sender.driver;
      this.getWebhookUrl(this.model.smtp_driver);
      if (this.model.smtp_driver === 2) {
        this.smtp_model.user_name = this.sender.user_name;
        this.smtp_model.api_key = this.sender.api_key;
        this.smtp_model.webhook_signing_key = this.sender.webhook_signing_key;
      } else if (this.model.smtp_driver === 3) {
        this.smtp_model.api_key = this.sender.api_key;
      } else if (this.model.smtp_driver === 4) {
        this.smtp_model.api_key = this.sender.api_key;
      } else if (this.model.smtp_driver === 5) {
        this.smtp_model.user_name = this.sender.user_name;
        this.smtp_model.api_key = this.sender.api_key;
        this.smtp_model.server = this.sender.server;
        this.smtp_model.configuration_set = this.sender.configuration_set;
      }
    }
    this.$wait.end('senderdetail');
  },

  computed: {
    tabs() {
      return [
        {
          title: `<span class="text-sm leads-field font-bold mr-3"></i>&nbsp;${this.$t(
            'frontend_groovemail_sender_sender_info_tab'
          )}<span>`,
          value: 'senderInfo',
        },
        {
          title: `<span class="text-sm leads-field font-bold mr-3"></i>&nbsp;${this.$t(
            'frontend_groovemail_sender_business_info_tab'
          )}<span>`,
          value: 'businessInfo',
        },
      ];
    },

    awsSteps() {
      return [
        {
          stepLabel: `<p><b>${this.$t(
            'frontend_groovemail_step'
          )} 1:</b> ${this.$t(
            'frontend_groovemail_aws_step_1'
          )} (<a target="_blank" href="https://aws.amazon.com/console/" class="cursor-pointer text-pink underline">click here to visit page</a>).</p>`,
        },
        {
          stepLabel: `<p><b>${this.$t(
            'frontend_groovemail_step'
          )} 2:</b> ${this.$t('frontend_groovemail_aws_step_2')}</p>`,
        },
        {
          stepLabel: `<p><b>${this.$t(
            'frontend_groovemail_step'
          )} 3:</b> ${this.$t('frontend_groovemail_aws_step_3')}</p>`,
        },
        {
          stepLabel: `<p><b>${this.$t(
            'frontend_groovemail_step'
          )} 4:</b> ${this.$t('frontend_groovemail_aws_step_4')}</p>`,
          subSteps: [
            {
              subStepLabel: `<span>${this.$t(
                'frontend_groovemail_aws_step_4_substep_1'
              )}</span>`,
            },
            {
              subStepLabel: `<span>${this.$t(
                'frontend_groovemail_aws_step_4_substep_2'
              )}</span>`,
            },
            {
              subStepLabel: `<span>${this.$t(
                'frontend_groovemail_aws_step_4_substep_3'
              )}</span>`,
            },
            {
              subStepLabel: `<span>${this.$t(
                'frontend_groovemail_aws_step_4_substep_4'
              )}</span>`,
            },
          ],
        },
        {
          stepLabel: `<p><b>${this.$t(
            'frontend_groovemail_step'
          )} 5:</b> ${this.$t('frontend_groovemail_aws_step_5')}</p>`,
        },
        {
          stepLabel: `<p><b>${this.$t(
            'frontend_groovemail_step'
          )} 6:</b> ${this.$t('frontend_groovemail_aws_step_6')}</p>`,
          subSteps: [
            {
              subStepLabel: `<span>${this.$t(
                'frontend_groovemail_aws_step_6_substep_1'
              )}</span>`,
            },
            {
              subStepLabel: `<span>${this.$t(
                'frontend_groovemail_aws_step_6_substep_2'
              )}</span>`,
            },
          ],
        },
        {
          stepLabel: `<p><b>${this.$t(
            'frontend_groovemail_step'
          )} 7:</b> ${this.$t('frontend_groovemail_aws_step_7')}</p>`,
        },
      ];
    },

    mailgunSteps() {
      return [
        {
          stepLabel: `<p><b>${this.$t(
            'frontend_groovemail_step'
          )} 1:</b> ${this.$t(
            'frontend_groovemail_mailgun_step_1_a'
          )} <a target="_blank" href="https://www.mailgun.com/" class="cursor-pointer text-pink underline">${this.$t(
            'frontend_groovemail_mailgun_step_1_b'
          )}</a> ${this.$t('frontend_groovemail_mailgun_step_1_c')}.</p>`,
        },
        {
          stepLabel: `<p><b>${this.$t(
            'frontend_groovemail_step'
          )} 2:</b> ${this.$t('frontend_groovemail_mailgun_step_2')}</p>`,
        },
        {
          stepLabel: `<p><b>${this.$t(
            'frontend_groovemail_step'
          )} 3:</b> ${this.$t('frontend_groovemail_mailgun_step_3')}</p>`,
        },
        {
          stepLabel: `<p><b>${this.$t(
            'frontend_groovemail_step'
          )} 4:</b> ${this.$t('frontend_groovemail_mailgun_step_4')}</p>`,
        },
        {
          stepLabel: `<p><b>${this.$t(
            'frontend_groovemail_step'
          )} 5:</b> ${this.$t('frontend_groovemail_mailgun_step_5')}</p>`,
          subSteps: [
            {
              subStepLabel: `<span>${this.$t(
                'frontend_groovemail_mailgun_step_5_substep_1'
              )}</span>`,
            },
            {
              subStepLabel: `<span>${this.$t(
                'frontend_groovemail_mailgun_step_5_substep_2'
              )}</span>`,
            },
            {
              subStepLabel: `<span>${this.$t(
                'frontend_groovemail_mailgun_step_5_substep_3'
              )}</span>`,
            },
          ],
        },
        {
          stepLabel: `<p><b>${this.$t(
            'frontend_groovemail_step'
          )} 6:</b> ${this.$t('frontend_groovemail_mailgun_step_6')}</p>`,
        },
      ];
    },

    // admin section controlled check
    // userCanAccessInternalSmtp() {
    //   return this.getCanAccessInternalSmtp();
    // },

    // new plans based limit check
    canUseGrooveMailSmtp() {
      return auth.fetchFeatureValue('groovemail_can_use_groovemail_smtp') == 1;
    },

    //  Can mail/Upgraded user/Sandbox mode check
    // userCanMail() {
    //   return this.getCanMail();
    // },
    //  Can mail/Upgraded user/Sandbox mode check

    mainTabClass() {
      if (this.currentTab === 'senderInfo') {
        return 'pb-2 gs-default-tabs-item';
      }
      return 'pb-2 gs-default-tabs-item';
    },

    smtp_options() {
      const smtpOptions = [];
      if (this.userCanAccessInternalSmtp) {
        smtpOptions.push({
          id: 1,
          title: 'GrooveMail SMTP',
          coming_soon: !this.canUseGrooveMailSmtp,
          disabled_message: !this.canUseGrooveMailSmtp
            ? this.$t('frontend_groovemail_sender_settings_restricted_smtp_for_free_account')
            : '',
        });
      }
      smtpOptions.push({
        id: 2,
        title: 'MailGun',
      });
      smtpOptions.push({
        id: 3,
        title: 'SendGrid',
      });
      smtpOptions.push({
        id: 4,
        title: 'SparkPost',
      });
      smtpOptions.push({
        id: 5,
        title: 'Amazon-SES',
      });
      return smtpOptions;
    },
  },
};
</script>
<style lang="scss">
.dropdown-toggle {
  background-image: none !important;
  border: 1px solid dodgerblue !important;
  border-radius: 30px;
  &:hover {
    background: transparent;
  }
}
.custom-radio-list {
  & > .rounded {
    padding: 0;
    margin: 0;
    border: none;
    .w-6 {
      height: 23px;
      margin: 0;
    }
    label.flex {
      margin-bottom: 16px;
    }
    label.font-semibold {
      font-size: 14px;
      font-weight: normal;
      color: #191d3a;
    }
  }
}
</style>